import type { EarlyFreedomAnchorOption } from "web_myplann/Inspiration/EarlyFreedom/constants";
import type { EarlyFreedomAnchorKey } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import type { InspirationAnchor } from "web_myplann/Inspiration/Types/InspirationTypes";

export const mapEarlyFreedomAnchor = (
	anchor: EarlyFreedomAnchorOption,
	activeKey: EarlyFreedomAnchorKey,
	targetExpenses: number,
): InspirationAnchor => ({
	key: anchor.key,
	icon: anchor.icon,
	label: anchor.copy.label,
	amount: anchor.amount,
	displayAmount:
		anchor.key === "luxury" && activeKey === "luxury"
			? targetExpenses
			: undefined,
});
